import React, { ReactElement } from "react";

import * as Styles from "./styles";

interface Props {
  children: ReactElement<any, any>;
}
export function DivisorContainer(props: Props) {
  return (
    <>
      <Styles.Container>
        <hr />
        {props.children}
        <hr />
      </Styles.Container>
    </>
  );
}
